import { translate } from "app/filters/i18nFilter";
import { columns } from "app/pages/industry-analysis/overview/pre-defined-industries-benchmarking/table/columns/columns";

const {
    favorite,
    industry,
    previousPeriodTotalVisits,
    currentPeriodTotalVisits,
    periodOverPeriodTotalVisitsChange,
    previousPeriodUniqueVisitors,
    currentPeriodUniqueVisitors,
    periodOverPeriodUniqueVisitorsChange,
} = columns;

export const yearOverYearColumns = [
    favorite,
    { ...industry, fixed: true },
    {
        ...previousPeriodTotalVisits,
        tooltip: () => translate("pre.defined.industries.table.columns.total.visits.previous.year.tooltip"),
    },
    {
        ...currentPeriodTotalVisits,
        tooltip: () => translate("pre.defined.industries.table.columns.total.visits.current.year.tooltip"),
    },
    {
        ...periodOverPeriodTotalVisitsChange,
        displayName: () => translate("pre.defined.industries.table.columns.total.visits.change.year.over.year"),
        tooltip: () => translate("pre.defined.industries.table.columns.total.visits.change.year.over.year.tooltip"),
    },
    {
        ...previousPeriodUniqueVisitors,
        tooltip: () => translate("pre.defined.industries.table.columns.year.over.year.unique.visitors.tooltip"),
    },
    currentPeriodUniqueVisitors,
    {
        ...periodOverPeriodUniqueVisitorsChange,
        displayName: () => translate("pre.defined.industries.table.columns.unique.visitors.change.year.over.year"),
        tooltip: () => translate("pre.defined.industries.table.columns.unique.visitors.change.year.over.year.tooltip"),
    },
];
